import React, { useState } from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { amenitiesCreationStore } from 'state/listing/amenitiesListing'
import { Photo } from 'types/globalTypes'
import { myStore } from 'state/store'
import UploadDocument from 'components/global/UploadDocument'
import {
  useCreateAmenity,
  useUpdateAmenity,
} from 'api/Listings/Amenties'

interface AmenitiesFormProps {
  form: FormInstance
  organizationId?: string
}

const AmenitiesForm: React.FC<AmenitiesFormProps> = ({
  form,
  organizationId,
}) => {
  const { amenitiesData, setAddAmenitiesModal } = amenitiesCreationStore(
    store => ({
      amenitiesData: store.amenitiesData,
      setAddAmenitiesModal: store.setAddAmenitiesModal,
    }),
  )
  const setModalBtnLoading = myStore(store => store.setModalBtnLoader)
  const [error, setError] = useState<string>('')
  const [documentIds, setDocumentIds] = useState<string[]>(
    amenitiesData ? [amenitiesData.iconId] : [],
  )
  const [photos] = useState<Photo[]>(
    amenitiesData ? [amenitiesData.icon] : [],
  )

  const formSchema = {
    name: amenitiesData ? amenitiesData.name : undefined,
  }

  const { mutate: createAmenity } = useCreateAmenity()
  const { mutate: updateAmenity } = useUpdateAmenity()

  const onFinish = (values: { name: string }) => {
    if (!documentIds[0]) {
      setError('Icon is required')
      return
    }

    const payload = {
      ...values,
      iconId: documentIds[0],
      organizationId: organizationId,
    }
    setModalBtnLoading(true)

    if (amenitiesData) {
      updateAmenity(
        { amenityId: amenitiesData._id, payload },
        {
          onSuccess: () => {
            setModalBtnLoading(false)
            setAddAmenitiesModal(false)
          },
          onError: () => {
            setModalBtnLoading(false)
          },
        },
      )
    } else {
      createAmenity(payload, {
        onSuccess: () => {
          setModalBtnLoading(false)
          setAddAmenitiesModal(false)
        },
        onError: () => {
          setModalBtnLoading(false)
        },
      })
    }
  }

  return (
    <>
      <Form
        name="amenities-form"
        form={form}
        initialValues={formSchema}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Row>
          <Col>
            <label className="custom-field-label">Add Icon</label>
          </Col>
          <Col span={12}>
            <UploadDocument
              documentIds={documentIds}
              setDocumentIds={setDocumentIds}
              multiple={true}
              docType="image/*"
              files={photos}
            />
          </Col>
          {error && (
            <Col className="-mt-20px" span={24}>
              <p className="ant-form-item-explain-error">{error}</p>
            </Col>
          )}
        </Row>
        <Row className="-mt-10px">
          <Col span={24}>
            <label className="input-label required-input">Name</label>
            <Form.Item
              colon={false}
              name="name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="Enter Name" required name="name" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default AmenitiesForm


